import { z } from 'zod'

// Identity Document Types
export const DocumentVariantSchema = z.number().transform((val) => {
  switch (val) {
    case 1:
      return 'DRIVERS_LICENSE' as const
    case 2:
      return 'ID_CARD' as const
    case 3:
      return 'PASSPORT' as const
    case 4:
      return 'RESIDENCY_PERMIT_CARD' as const
    case 5:
      return 'TEMPORARY_VISA' as const
    case 6:
      return 'BIRTH_CERTIFICATE' as const
    case 7:
      return 'TAX_INCOME_1040' as const
    case 8:
      return 'PAPER_PASSPORT' as const
    case 9:
      return 'OTHER' as const
    case 10:
      return 'TAX_INCOME_W2' as const
    case 11:
      return 'TAX_INCOME_1099' as const
    case 12:
      return 'SOCIAL_SECURITY_AWARD_LETTER' as const

    case 16:
      return 'NON_TAXABLE_INCOME' as const
    case 17:
      return 'PORTFOLIO' as const
    default:
      throw new Error(`Invalid identity document code: ${val}`)
  }
})

// Document Category
export const DocumentCategorySchema = z.number().transform((val) => {
  switch (val) {
    case 1:
      return 'IDENTITY' as const
    case 2:
      return 'TAX' as const
    case 3:
      return 'STUDENT' as const
    default:
      throw new Error(`Invalid document category code: ${val}`)
  }
})

// Inferred types
export type DocumentVariant = z.infer<typeof DocumentVariantSchema>
export type DocumentCategory = z.infer<typeof DocumentCategorySchema>
